module.exports = __webpack_public_path__ + "img/avatar.81b0ef17.png";